/* eslint-disable react/prop-types */

'use strict';

const { Component, h } = require('preact');

const OptionMessages = require('./messages/template');
const OptionPricing = require('./pricing');
const UrgencyPriceLabel = require('./pricing/urgency_price_label');

const renderTitle = props => {
  const {
    isPriceSummary,
    isTraitsSummary,
    option: { title },
  } = props;
  if (!title || isPriceSummary || isTraitsSummary) {
    return null;
  }
  return h('h3', null, title);
};

class OptionDetails extends Component {
  constructor(props) {
    super(props);

    const { isTraitSummary, option, priceSummary } = props;
    const currentOption = option || priceSummary;
    const showPriceLabel = !!currentOption.pricing.pricingLabel;
    this.state = {
      allTraitsSelected: isTraitSummary ? false : undefined,
      currentOption,
      showPriceLabel,
    };

    this.renderOptionMessage = this.renderOptionMessage.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line
    window.BuyButtonEventPipe.on(
      'option_updated',
      ({ allTraitsSelected, optionUuid }) => {
        const newOption = this.props.multiOption.find(
          option => option.uuid === optionUuid
        );
        if (newOption) {
          this.setState({
            allTraitsSelected,
            currentOption: newOption,
          });
        }
      }
    );
  }

  renderOptionMessage(msg) {
    return msg ? h(OptionMessages, msg) : null;
  }

  render(props, { allTraitsSelected, currentOption }) {
    const { isTraitsSummary, defaultMessages } = props;
    const {
      isModalOption,
      isUrgencyPricing,
      showDoubleStrikeThroughPrice,
      pricing: { pricingLabel, showIlsTimeLeft },
    } = currentOption;

    const propsToPass = {
      ...props,
      option: currentOption,
      showPriceLabel:
        !!pricingLabel && (!isTraitsSummary || !allTraitsSelected),
    };

    const showUrgencyPriceLabel =
      isTraitsSummary || (!showDoubleStrikeThroughPrice && isModalOption);

    const breakoutMessagesClasses = `breakout-messages${
      isTraitsSummary ? ' has-traits' : ''
    }${showIlsTimeLeft ? ' with-price-label' : ''}${
      isUrgencyPricing ? ' urgency-pricing-offer' : ''
    }`;

    let messagesView;
    if (isTraitsSummary && !allTraitsSelected) {
      messagesView = defaultMessages.map(this.renderOptionMessage);
    } else {
      messagesView = propsToPass.option.messages.map(this.renderOptionMessage);
    }

    return h(
      'div',
      {
        class: 'option-details c-txt-gray-dk',
      },
      renderTitle(propsToPass),
      h(
        'div',
        {
          class: 'breakout-pricing-messages',
        },
        h(
          'div',
          {
            class: breakoutMessagesClasses,
          },
          messagesView,
          showUrgencyPriceLabel ? h(UrgencyPriceLabel, propsToPass) : null
        ),
        h(OptionPricing, propsToPass)
      )
    );
  }
}

module.exports = OptionDetails;
